/* eslint-disable */
// THIS FILE WAS GENERATED
// ALL CHANGES WILL BE OVERWRITTEN

// INFRASTRUCTURE START
  export type StandardError = globalThis.Error;
  export type Error500s = 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 510 | 511;
  export type ErrorStatuses = 0 | Error500s;
  export type ErrorResponse = FetchResponse<unknown, ErrorStatuses>;

  export type FetchResponseOfError = {
    data: null;
    error: StandardError;
    status: ErrorStatuses;
    args: FetchArgs;
  };

  export type FetchResponseOfSuccess<TData, TStatus extends number = 0> = 
  {
    data: TData;
    error: null;
    status: TStatus;
    args: FetchArgs;
    responseHeaders: Headers;
  };

  export type FetchResponse<TData, TStatus extends number = 0> = 
    TStatus extends ErrorStatuses ? FetchResponseOfError: FetchResponseOfSuccess<TData, TStatus>;

  export type TerminateRequest = null;
  export type TerminateResponse = null;

  export type Configuration = {
    apiUrl: string | (() => string);
    jwtKey: string | undefined | (() => string | null | undefined);
    requestMiddlewares?: Array<{
      name: string;
      fn: (request: FetchArgs) => FetchArgs | TerminateRequest;
    }>;
    responseMiddlewares?: Array<{
      name: string;
      fn: <TData, TStatus extends number>(
        response: FetchResponse<TData, TStatus>,
      ) => FetchResponse<TData, TStatus> | TerminateResponse;
    }>;
  };

  let CONFIG: Configuration = {
    apiUrl: () => "",
    jwtKey: undefined,
    requestMiddlewares: [],
    responseMiddlewares: [],
  };

  export function setupClient(configuration: Configuration) {
    CONFIG = {
      ...CONFIG,
      ...configuration,
      requestMiddlewares: [
        ...(CONFIG.requestMiddlewares || []),
        ...(configuration.requestMiddlewares || []),
      ],
      responseMiddlewares: [
        ...(CONFIG.responseMiddlewares || []),
        ...(configuration.responseMiddlewares || []),
      ],
    };
  }

  export function getApiUrl() {
    if (typeof CONFIG.apiUrl === "function") {
      return CONFIG.apiUrl();
    }
    return CONFIG.apiUrl;
  }

  export type Termination = {
    termination: {
      name: string;
    };
  };

  export function processRequestWithMiddlewares(
    request: FetchArgs
  ): FetchArgs | Termination {
    for (const middleware of CONFIG.requestMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(request);
        if (middlewareResponse === null) {
          return { termination: { name: middleware.name } };
        }
        return middlewareResponse;
      } catch (e) {
        console.error("Request middleware error", e);
      }
    }
    return request;
  }

  export function processResponseWithMiddlewares<TData, TStatus extends number>(
    response: FetchResponse<TData, TStatus>,
  ): FetchResponse<TData, TStatus | 0> {
    for (const middleware of CONFIG.responseMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(response);
        if (middlewareResponse === null) {
          return {
            status: 0,
            args: response.args,
            data: null,
            error: new Error(
              `Response terminated by middleware: ${middleware.name}`
            ),
          } satisfies FetchResponseOfError;
        }
        response = middlewareResponse;
      } catch (e) {
        console.error("Response middleware error", e);
      }
    }
    return response;
  }

  export type FetchArgsOptions = Omit<RequestInit, "method" | "redirect" | "body">;

  export type FetchArgs = {
    url: string;
    options: RequestInit;
  }

  export type UriComponent = string | number | boolean;
  export type ParamsObject = {
    [key: string]: UriComponent | UriComponent[] | undefined | null;
  };

  export async function fetchJson<TData>(args: FetchArgs): Promise<FetchResponse<TData, number> | FetchResponseOfError> {
    const errorResponse = (error: StandardError, status: number, args: FetchArgs) => {  
      const errorResponse = {
        status: status as ErrorStatuses,
        args,
        data: null,
        error,
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    const errorStatus = (args: FetchArgs) => {
      const errorResponse = {
        status: 0,
        args,
        data: null,
        error: new Error("Network error"),
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    try {
      const fetchRequest = processRequestWithMiddlewares(args);

      if ("termination" in fetchRequest) {
        const terminationResponse = {
          status: 0,
          args,
          data: null,
          error: new Error(
            `Request terminated by middleware: ${fetchRequest.termination.name}`
          ),
        } satisfies FetchResponseOfError;

        return processResponseWithMiddlewares(terminationResponse);
      }

      const fetchResponse: Response = await fetch(fetchRequest.url, fetchRequest.options);
      const status = fetchResponse.status;
      try {
        const json = await fetchResponse.json();
        const response = {
          data: json,
          status: fetchResponse.status,
          args,
          error: null,
          responseHeaders: fetchResponse.headers,
        };
        return processResponseWithMiddlewares(response);
      } catch (error) {
        return errorResponse(error as StandardError, status, args);
      }
    } catch {
      return errorStatus(args);
    }
  }

  export function getJwtKey(): string | null | undefined {
    if (typeof CONFIG.jwtKey === "function") {
      return CONFIG.jwtKey();
    }

    if (typeof CONFIG.jwtKey === "string") {
      return localStorage.getItem(CONFIG.jwtKey);
    }

    return undefined;
  } 
  
  
 function getApiRequestData<Type extends any>(
    requestContract: Type | undefined,
    isFormData: boolean = false
  ): FormData | Type | {} {
  
    if (!isFormData) {
      return requestContract !== undefined ? requestContract : {};
    }
  
    //multipart/form-data
    const formData = new FormData();
  
     if (requestContract) {
      Object.keys(requestContract).forEach(key => {
        const value = requestContract[key as keyof Type];
        const isKeyArrayAndValueIterable = key.endsWith('[]') && typeof (value as any)[Symbol.iterator] === 'function';
        const values = isKeyArrayAndValueIterable ? Array.from(value as Iterable<any>) : [value];
          for (const val of values) {
              if (val === undefined) {
                  continue;
              }
              if (val === null) {
                  formData.append(key, '');
              } else if (val instanceof File) {
                  formData.append(key, val);
              } else if (typeof val === 'object' && val !== null) {
                  formData.append(key, JSON.stringify(val));
              } else {
                  formData.append(key, val);
              }
          }
      });
    }
  
    return formData;
  }

  
function updateHeaders(headers: HeadersInit) {
  const token = getJwtKey();
  if (headers instanceof Headers) {
    if (!headers.has("Content-Type")) {
      headers.append("Content-Type", "application/json");
    }
    if (!headers.has("Authorization") && !!token) {
      headers.append("Authorization", token);
    }
    return;
  }

  if (Array.isArray(headers)) {
    if (!headers.find(([key]) => key === "Content-Type")) {
      headers.push(["Content-Type", "application/json"]);
    }
    if (!headers.find(([key]) => key === "Authorization") && !!token) {
      headers.push(["Authorization", token]);
    }
    return;
  }

  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (!headers.Authorization && !!token) {
    headers.Authorization = token;
  }
}

function removeContentTypeHeader(headers: HeadersInit) {
  if (headers instanceof Headers) {
    headers.delete("Content-Type");
    return;
  }

  if (Array.isArray(headers)) {
    return headers.filter(([key]) => key !== "Content-Type");
  }

  delete headers["Content-Type"];
}

export function createRequest<TRequest>(
  method: string,
  request: TRequest | undefined,
  options: FetchArgsOptions | undefined,
  url: string,
  paramsObject: ParamsObject = {},
) {
  const fetchOptions = options ?? {};

  if (!fetchOptions.headers) {
    fetchOptions.headers = new Headers();
  }

  updateHeaders(fetchOptions.headers);
  if (request instanceof FormData) {
    removeContentTypeHeader(fetchOptions.headers);
  }

  const body = request instanceof FormData ? request : (request !== undefined ? JSON.stringify(request) : undefined);
  const maybeQueryString = getQueryParamsString(paramsObject);

  const requestOptions: RequestInit = {
    ...fetchOptions,
    method,
    body,
    redirect: "follow",
  };

  return { options: requestOptions, url: `${url}${maybeQueryString}` } as FetchArgs;
}

export function getQueryParamsString(paramsObject: ParamsObject = {}) {
	const queryString = Object.entries(paramsObject)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map(val => `${encodeURIComponent(key)}=${encodeURIComponent(
            val,
          )}`)
          .join('&');
      }
      // Handling non-array parameters
      return value !== undefined && value !== null 
        ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` 
        : '';
    })
    .filter(part => part !== '')
    .join("&");

	return queryString.length > 0 ? `?${queryString}` : '';
}

export function apiPost<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("POST", request, options, url, paramsObject));
}

export function apiGet<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("GET", undefined, options, url, paramsObject));
}

export function apiPut<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PUT", request, options, url, paramsObject));
}

export function apiDelete<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("DELETE", undefined, options, url, paramsObject));
}

export function apiPatch<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PATCH", request, options, url, paramsObject));
}
// INFRASTRUCTURE END

export type ApiProblemDetails = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export type ErrorDetail = {
	code: ErrorCode;
	message?: string | null;
};

export enum ErrorCode {
	Unspecified = "Unspecified",
	OutOfRange = "OutOfRange",
	NotFound = "NotFound",
	Invalid = "Invalid",
	Forbidden = "Forbidden",
	TooManyRequests = "TooManyRequests",
	Conflict = "Conflict",
	NullOrEmpty = "NullOrEmpty",
	Unauthorized = "Unauthorized",
	ExternalProviderNotAvailable = "ExternalProviderNotAvailable"
};

export type ProblemDetails = {
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export type EntityListOfUserListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: UserListItemDto[];
};

export type UserListItemDto = {
	userID: number;
	login: string;
	firstName: string;
	lastName: string;
	tenantCode: string;
	dateCreated: string;
	isActive: boolean;
};

export type UserDetailDto = {
	userID: number;
	login: string;
	email: string;
	firstName?: string | null;
	lastName?: string | null;
	lastSignInDate?: string | null;
	phone?: string | null;
	userIdentityProviders: IdentityProvider[];
	profilePicture?: string | null;
	status: UserStatus;
};

export enum IdentityProvider {
	Application = "Application",
	Google = "Google",
	BankID = "BankID"
};

export enum UserStatus {
	Unknown = "Unknown",
	Active = "Active",
	WaitingForEmailConfirmation = "WaitingForEmailConfirmation"
};

export type SaveUserNotificationSettingsCommandResult = {};

export type UserNotificationUpdateRequest = {
	isEmailNotificationActive: boolean;
};

export type GetCodeListCollectionQueryResult = {
	countries: CodeListItemDto[];
};

export type CodeListItemDto = {
	id: number;
	code: string;
	name: string;
};

export type SignUpCommandResult = {};

export type ApiProblemDetailsOfSignUpErrorStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum SignUpErrorStatus {
	UserExists = "UserExists",
	TenantCodeRequired = "TenantCodeRequired",
	TenantNotFound = "TenantNotFound",
	NotAuthorised = "NotAuthorised"
};

export type ApiProblemDetailsOfPasswordChangeResultStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum PasswordChangeResultStatus {
	PasswordNotMatch = "PasswordNotMatch",
	NullOrEmpty = "NullOrEmpty",
	TooShort = "TooShort",
	Success = "Success"
};

export type SignUpCommand = {
	login: string;
	password: string;
	tenantCode: string;
};

export type SignInResult = {
	userInfo: UserInfo;
	isFirstSignIn: boolean;
};

export type UserInfo = {
	token: string;
	login: string;
	firstName: string;
	lastName: string;
	tenantName: string;
	userIdentityProviders: IdentityProvider[];
	accessRightCodes: string[];
	profilePicture?: string | null;
};

export type ApiProblemDetailsOfAuthError = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum AuthError {
	ApplicationVerification = "ApplicationVerification",
	InvalidCredentials = "InvalidCredentials",
	AccountIsDisabled = "AccountIsDisabled",
	PhoneNumberNotFound = "PhoneNumberNotFound",
	SmsSendingFailed = "SmsSendingFailed",
	InvalidToken = "InvalidToken",
	AccountWaitingForEmailConfirmation = "AccountWaitingForEmailConfirmation"
};

export type SignInCommand = {
	login: string;
	password: string;
};

export type EmailVerificationCommandResult = {
	signInResult: SignInResult;
};

export type ApiProblemDetailsOfEmailVerificationCommandResultStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum EmailVerificationCommandResultStatus {
	TokenNotFound = "TokenNotFound",
	UserNotFound = "UserNotFound"
};

export type EmailVerificationCommand = {
	token: string;
};

export type ResendVerificationEmailCommandResult = {};

export type ResendVerificationEmailCommand = {
	email: string;
};

export type SsoSignInRequest = {
	token: string;
	identityProvider: IdentityProvider;
};

export type ResetPasswordCommandResult = {};

export type ApiProblemDetailsOfResetPasswordCommandResultStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum ResetPasswordCommandResultStatus {
	Fail = "Fail"
};

export type ResetPasswordCommand = {
	login: string;
};

export type SetPasswordCommandResult = {
	signInResult: SignInResult;
};

export type ApiProblemDetailsOfSetPasswordCommandStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum SetPasswordCommandStatus {
	TokenNotFound = "TokenNotFound"
};

export type SetPasswordCommand = {
	token: string;
	password: string;
};

export type GetUsersFetchResponse = 
| FetchResponse<EntityListOfUserListItemDto, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getUsersPath = () => `/api/v1/users`;

export const getUsers = (offset?: number, limit?: number, options?: FetchArgsOptions):
  Promise<GetUsersFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getUsersPath()}`, options, queryParams) as Promise<GetUsersFetchResponse>;
}

export type GetUsersUserIDFetchResponse =
| FetchResponse<UserDetailDto, 200>
| FetchResponse<ApiProblemDetails, 401>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const getUsersUserIDPath = (userID: number) => `/api/v1/users/${userID}`;

export const getUsersUserID = (userID: number, options?: FetchArgsOptions):
  Promise<GetUsersUserIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersUserIDPath(userID)}`, options, {}) as Promise<GetUsersUserIDFetchResponse>;
}

export type ExtractionConfigurationListItemDto = {
	extractionConfigurationID: number;
	name: string;
	prompt: string;
	jsonSchema: string;
	connectorConfigurationID: number;
	connectorProvider: string;
	pageLimit: number | null;
	forceOcr: boolean;
	identificationHints: string | null;
	tenantCode: string | null;
	isActive: boolean;
	isFallback: boolean;
	parentConfigurationID: number | null;
	parentName: string | null;
};

export type EntityListOfExtractionConfigurationListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: ExtractionConfigurationListItemDto[];
};

export type GetExtractionConfigurationsFetchResponse =
| FetchResponse<EntityListOfExtractionConfigurationListItemDto, 200>
| FetchResponse<ApiProblemDetails, 401>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const getExtractionConfigurationsPath = () => `/api/v1/extraction-configurations`;

export const getExtractionConfigurations = (offset?: number, limit?: number, searchQuery?: string | null, options?: FetchArgsOptions):
  Promise<GetExtractionConfigurationsFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit,
      "searchQuery": searchQuery
    }
    return apiGet(`${getApiUrl()}${getExtractionConfigurationsPath()}`, options, queryParams) as Promise<GetExtractionConfigurationsFetchResponse>;
}

export type CreateExtractionConfigurationCommand = {
	name: string;
	prompt: string;
	jsonSchema: string;
	connectorConfigurationId: number;
	pageLimit?: number | null;
	forceOcr?: boolean;
	identificationHints?: string | null;
	isFallback?: boolean;
	parentConfigurationId?: number | null;
	tenantId?: number | null;
};

export type PostExtractionConfigurationsFetchResponse =
| FetchResponse<number, 201>
| FetchResponse<ApiProblemDetails, 401>
| FetchResponse<ApiProblemDetails, 409>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const postExtractionConfigurationsPath = () => `/api/v1/extraction-configurations`;

export const postExtractionConfigurations = (requestContract: CreateExtractionConfigurationCommand, options?: FetchArgsOptions):
  Promise<PostExtractionConfigurationsFetchResponse> => {
    const requestData = getApiRequestData<CreateExtractionConfigurationCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postExtractionConfigurationsPath()}`, requestData, options) as Promise<PostExtractionConfigurationsFetchResponse>;
}

export type DeleteExtractionConfigurationFetchResponse =
| FetchResponse<void, 204>
| FetchResponse<ProblemDetails, 404>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const deleteExtractionConfigurationPath = (id: number) => `/api/v1/extraction-configurations/${id}`;

export const deleteExtractionConfiguration = (id: number, options?: FetchArgsOptions):
  Promise<DeleteExtractionConfigurationFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteExtractionConfigurationPath(id)}`, options) as Promise<DeleteExtractionConfigurationFetchResponse>;
}

export type DuplicateExtractionConfigurationFetchResponse =
| FetchResponse<number, 201>
| FetchResponse<ProblemDetails, 404>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const duplicateExtractionConfigurationPath = (id: number) => `/api/v1/extraction-configurations/${id}/duplicate`;

export const duplicateExtractionConfiguration = (id: number, options?: FetchArgsOptions):
  Promise<DuplicateExtractionConfigurationFetchResponse> => {
    return apiPost(`${getApiUrl()}${duplicateExtractionConfigurationPath(id)}`, {}, options) as Promise<DuplicateExtractionConfigurationFetchResponse>;
}

export type UpdateExtractionConfigurationCommand = {
	name: string;
	prompt: string;
	jsonSchema: string;
	connectorConfigurationId: number;
	pageLimit?: number | null;
	forceOcr?: boolean;
	identificationHints?: string | null;
	isFallback?: boolean | null;
	parentConfigurationId?: number | null;
	tenantId?: number | null;
};

export type PutExtractionConfigurationFetchResponse =
| FetchResponse<void, 204>
| FetchResponse<ProblemDetails, 404>
| FetchResponse<ApiProblemDetails, 409>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const putExtractionConfigurationPath = (id: number) => `/api/v1/extraction-configurations/${id}`;

export const putExtractionConfiguration = (id: number, requestContract: UpdateExtractionConfigurationCommand, options?: FetchArgsOptions):
  Promise<PutExtractionConfigurationFetchResponse> => {
    const requestData = getApiRequestData<UpdateExtractionConfigurationCommand>(requestContract, false);
    return apiPut(`${getApiUrl()}${putExtractionConfigurationPath(id)}`, requestData, options) as Promise<PutExtractionConfigurationFetchResponse>;
}

export type ExtractDocumentRequest = {
	files?: File[];
	documentType?: string;
	hint?: string;
	pageSelection?: string;
};

export type ExtractionUsage = {
	promptTokens: number;
	completionTokens: number;
	totalTokens: number;
};

export type ExtractionResult = {
	content: any;
	contentType: string;
	metadata: any;
	usage: ExtractionUsage;
	statusMessages: string[];
};

export type PostDocumentsExtractFetchResponse =
| FetchResponse<ExtractionResult, 200>
| FetchResponse<ApiProblemDetails, 400>
| FetchResponse<ApiProblemDetails, 401>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const postDocumentsExtractPath = () => `/api/v2/documents/extract`;

export const postDocumentsExtract = (requestContract: ExtractDocumentRequest, options?: FetchArgsOptions):
  Promise<PostDocumentsExtractFetchResponse> => {
    const formData = new FormData();

    if (requestContract.files) {
      for (const file of requestContract.files) {
        formData.append('Files', file);
      }
    }

    if (requestContract.documentType) {
      formData.append('DocumentType', requestContract.documentType);
    }

    if (requestContract.hint) {
      formData.append('Hint', requestContract.hint);
    }

    if (requestContract.pageSelection) {
      formData.append('PageSelection', requestContract.pageSelection);
    }

    return apiPost(`${getApiUrl()}${postDocumentsExtractPath()}`, formData, options) as Promise<PostDocumentsExtractFetchResponse>;
}

export type ExtractionListItemDto = {
	extractionID: number;
	requestTime: string;
	inputTokens: number;
	outputTokens: number;
	cachedTokens: number;
	userID: number;
	userName: string;
	userEmail: string;
	extractionConfigurationID: number;
	extractionConfigurationName: string;
	tenantCode: string | null;
	isActive: boolean;
};

export type EntityListOfExtractionListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: ExtractionListItemDto[];
};

export type GetExtractionsFetchResponse =
| FetchResponse<EntityListOfExtractionListItemDto, 200>
| FetchResponse<ApiProblemDetails, 401>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const getExtractionsPath = () => `/api/v1/extractions`;

export const getExtractions = (offset: number, limit: number, searchQuery?: string | null, options?: FetchArgsOptions):
  Promise<GetExtractionsFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit,
      "searchQuery": searchQuery
    }
    return apiGet(`${getApiUrl()}${getExtractionsPath()}`, options, queryParams) as Promise<GetExtractionsFetchResponse>;
}

export type ConnectorConfigurationListItemDto = {
	connectorConfigurationID: number;
	provider: string;
	endpoint: string;
	apiKey: string;
	tenantCode: string | null;
	isActive: boolean;
};

export type EntityListOfConnectorConfigurationListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: ConnectorConfigurationListItemDto[];
};

export type GetConnectorConfigurationsFetchResponse =
| FetchResponse<EntityListOfConnectorConfigurationListItemDto, 200>
| FetchResponse<ApiProblemDetails, 401>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const getConnectorConfigurationsPath = () => `/api/v1/connector-configurations`;

export const getConnectorConfigurations = (offset?: number, limit?: number, options?: FetchArgsOptions):
  Promise<GetConnectorConfigurationsFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getConnectorConfigurationsPath()}`, options, queryParams) as Promise<GetConnectorConfigurationsFetchResponse>;
}

export type CreateConnectorConfigurationCommand = {
	provider: string;
	endpoint: string;
	apiKey: string;
};

export type PostConnectorConfigurationsFetchResponse =
| FetchResponse<number, 201>
| FetchResponse<ApiProblemDetails, 401>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const postConnectorConfigurationsPath = () => `/api/v1/connector-configurations`;

export const postConnectorConfigurations = (requestContract: CreateConnectorConfigurationCommand, options?: FetchArgsOptions):
  Promise<PostConnectorConfigurationsFetchResponse> => {
    const requestData = getApiRequestData<CreateConnectorConfigurationCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postConnectorConfigurationsPath()}`, requestData, options) as Promise<PostConnectorConfigurationsFetchResponse>;
}

export type DeleteConnectorConfigurationFetchResponse =
| FetchResponse<void, 204>
| FetchResponse<ProblemDetails, 404>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const deleteConnectorConfigurationPath = (id: number) => `/api/v1/connector-configurations/${id}`;

export const deleteConnectorConfiguration = (id: number, options?: FetchArgsOptions):
  Promise<DeleteConnectorConfigurationFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteConnectorConfigurationPath(id)}`, options) as Promise<DeleteConnectorConfigurationFetchResponse>;
}

export type UpdateConnectorConfigurationCommand = {
	provider: string;
	endpoint: string;
	apiKey: string;
};

export type PutConnectorConfigurationFetchResponse =
| FetchResponse<void, 204>
| FetchResponse<ProblemDetails, 404>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const putConnectorConfigurationPath = (id: number) => `/api/v1/connector-configurations/${id}`;

export const putConnectorConfiguration = (id: number, requestContract: UpdateConnectorConfigurationCommand, options?: FetchArgsOptions):
  Promise<PutConnectorConfigurationFetchResponse> => {
    const requestData = getApiRequestData<UpdateConnectorConfigurationCommand>(requestContract, false);
    return apiPut(`${getApiUrl()}${putConnectorConfigurationPath(id)}`, requestData, options) as Promise<PutConnectorConfigurationFetchResponse>;
}

export type TenantListItemDto = {
	tenantID: number;
	code: string;
	userCount: number;
	extractionConfigurationCount: number;
	isActive: boolean;
};

export type EntityListOfTenantListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: TenantListItemDto[];
};

export type GetTenantsFetchResponse =
| FetchResponse<EntityListOfTenantListItemDto, 200>
| FetchResponse<ApiProblemDetails, 401>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const getTenantsPath = () => `/api/v1/tenants`;

export const getTenants = (offset?: number, limit?: number, options?: FetchArgsOptions):
  Promise<GetTenantsFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getTenantsPath()}`, options, queryParams) as Promise<GetTenantsFetchResponse>;
}

export type CreateTenantCommand = {
	code: string;
};

export type PostTenantsFetchResponse =
| FetchResponse<number, 201>
| FetchResponse<ApiProblemDetails, 401>
| FetchResponse<ApiProblemDetails, 409>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const postTenantsPath = () => `/api/v1/tenants`;

export const postTenants = (requestContract: CreateTenantCommand, options?: FetchArgsOptions):
  Promise<PostTenantsFetchResponse> => {
    const requestData = getApiRequestData<CreateTenantCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTenantsPath()}`, requestData, options) as Promise<PostTenantsFetchResponse>;
}

export type DeleteTenantFetchResponse =
| FetchResponse<void, 204>
| FetchResponse<ApiProblemDetails, 404>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const deleteTenantPath = (id: number) => `/api/v1/tenants/${id}`;

export const deleteTenant = (id: number, options?: FetchArgsOptions):
  Promise<DeleteTenantFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteTenantPath(id)}`, options) as Promise<DeleteTenantFetchResponse>;
}

export type UpdateTenantCommand = {
	code: string;
};

export type PutTenantFetchResponse =
| FetchResponse<void, 204>
| FetchResponse<ApiProblemDetails, 404>
| FetchResponse<ApiProblemDetails, 409>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const putTenantPath = (id: number) => `/api/v1/tenants/${id}`;

export const putTenant = (id: number, requestContract: UpdateTenantCommand, options?: FetchArgsOptions):
  Promise<PutTenantFetchResponse> => {
    const requestData = getApiRequestData<UpdateTenantCommand>(requestContract, false);
    return apiPut(`${getApiUrl()}${putTenantPath(id)}`, requestData, options) as Promise<PutTenantFetchResponse>;
}

export type TenantUserDto = {
	userID: number;
	email: string;
	firstName: string;
	lastName: string;
	roles: string[];
};

export type GetTenantUsersFetchResponse =
| FetchResponse<TenantUserDto[], 200>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const getTenantUsersPath = (id: number) => `/api/v1/tenants/${id}/users`;

export const getTenantUsers = (id: number, options?: FetchArgsOptions):
  Promise<GetTenantUsersFetchResponse> => {
    return apiGet(`${getApiUrl()}${getTenantUsersPath(id)}`, options) as Promise<GetTenantUsersFetchResponse>;
}

export type TenantExtractionConfigurationDto = {
	extractionConfigurationID: number;
	name: string;
};

export type GetTenantExtractionConfigurationsFetchResponse =
| FetchResponse<TenantExtractionConfigurationDto[], 200>
| FetchResponse<ProblemDetails, 500>
| ErrorResponse;

export const getTenantExtractionConfigurationsPath = (id: number) => `/api/v1/tenants/${id}/extraction-configurations`;

export const getTenantExtractionConfigurations = (id: number, options?: FetchArgsOptions):
  Promise<GetTenantExtractionConfigurationsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getTenantExtractionConfigurationsPath(id)}`, options) as Promise<GetTenantExtractionConfigurationsFetchResponse>;
}

export type PutNotificationsUserSettingsFetchResponse = 
| FetchResponse<SaveUserNotificationSettingsCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putNotificationsUserSettingsPath = () => `/api/v1/notifications/user-settings`;

export const putNotificationsUserSettings = (requestContract: UserNotificationUpdateRequest, options?: FetchArgsOptions):
  Promise<PutNotificationsUserSettingsFetchResponse> => {
    const requestData = getApiRequestData<UserNotificationUpdateRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putNotificationsUserSettingsPath()}`, requestData, options) as Promise<PutNotificationsUserSettingsFetchResponse>;
}

export type GetCodeListsFetchResponse = 
| FetchResponse<GetCodeListCollectionQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getCodeListsPath = () => `/api/v1/code-lists`;

export const getCodeLists = (options?: FetchArgsOptions):
  Promise<GetCodeListsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCodeListsPath()}`, options, {}) as Promise<GetCodeListsFetchResponse>;
}

export type PostAuthSignUpFetchResponse = 
| FetchResponse<SignUpCommandResult, 201> 
| FetchResponse<ApiProblemDetailsOfPasswordChangeResultStatus, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfSignUpErrorStatus, 403> 
| FetchResponse<ApiProblemDetailsOfSignUpErrorStatus, 409> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthSignUpPath = () => `/api/v1/auth/sign-up`;

export const postAuthSignUp = (requestContract: SignUpCommand, options?: FetchArgsOptions):
  Promise<PostAuthSignUpFetchResponse> => {
    const requestData = getApiRequestData<SignUpCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSignUpPath()}`, requestData, options) as Promise<PostAuthSignUpFetchResponse>;
}

export type PostAuthSignInFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetailsOfAuthError, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthSignInPath = () => `/api/v1/auth/sign-in`;

export const postAuthSignIn = (requestContract: SignInCommand, options?: FetchArgsOptions):
  Promise<PostAuthSignInFetchResponse> => {
    const requestData = getApiRequestData<SignInCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSignInPath()}`, requestData, options) as Promise<PostAuthSignInFetchResponse>;
}

export type PostAuthEmailVerificationFetchResponse = 
| FetchResponse<EmailVerificationCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfEmailVerificationCommandResultStatus, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthEmailVerificationPath = () => `/api/v1/auth/email-verification`;

export const postAuthEmailVerification = (requestContract: EmailVerificationCommand, options?: FetchArgsOptions):
  Promise<PostAuthEmailVerificationFetchResponse> => {
    const requestData = getApiRequestData<EmailVerificationCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthEmailVerificationPath()}`, requestData, options) as Promise<PostAuthEmailVerificationFetchResponse>;
}

export type PostAuthEmailVerificationSendFetchResponse = 
| FetchResponse<ResendVerificationEmailCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthEmailVerificationSendPath = () => `/api/v1/auth/email-verification/send`;

export const postAuthEmailVerificationSend = (requestContract: ResendVerificationEmailCommand, options?: FetchArgsOptions):
  Promise<PostAuthEmailVerificationSendFetchResponse> => {
    const requestData = getApiRequestData<ResendVerificationEmailCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthEmailVerificationSendPath()}`, requestData, options) as Promise<PostAuthEmailVerificationSendFetchResponse>;
}

export type PostAuthSsoFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfAuthError, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthSsoPath = () => `/api/v1/auth/sso`;

export const postAuthSso = (requestContract: SsoSignInRequest, options?: FetchArgsOptions):
  Promise<PostAuthSsoFetchResponse> => {
    const requestData = getApiRequestData<SsoSignInRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSsoPath()}`, requestData, options) as Promise<PostAuthSsoFetchResponse>;
}

export type PostAuthPasswordResetFetchResponse = 
| FetchResponse<ResetPasswordCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfResetPasswordCommandResultStatus, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthPasswordResetPath = () => `/api/v1/auth/password-reset`;

export const postAuthPasswordReset = (requestContract: ResetPasswordCommand, options?: FetchArgsOptions):
  Promise<PostAuthPasswordResetFetchResponse> => {
    const requestData = getApiRequestData<ResetPasswordCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthPasswordResetPath()}`, requestData, options) as Promise<PostAuthPasswordResetFetchResponse>;
}

export type PutAuthPasswordFetchResponse = 
| FetchResponse<SetPasswordCommandResult, 200> 
| FetchResponse<ApiProblemDetailsOfPasswordChangeResultStatus, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfSetPasswordCommandStatus, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putAuthPasswordPath = () => `/api/v1/auth/password`;

export const putAuthPassword = (requestContract: SetPasswordCommand, options?: FetchArgsOptions):
  Promise<PutAuthPasswordFetchResponse> => {
    const requestData = getApiRequestData<SetPasswordCommand>(requestContract, false);

    return apiPut(`${getApiUrl()}${putAuthPasswordPath()}`, requestData, options) as Promise<PutAuthPasswordFetchResponse>;
}

export type GetAuthUserinfoFetchResponse = 
| FetchResponse<UserInfo, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getAuthUserinfoPath = () => `/api/v1/auth/userinfo`;

export const getAuthUserinfo = (options?: FetchArgsOptions):
  Promise<GetAuthUserinfoFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAuthUserinfoPath()}`, options, {}) as Promise<GetAuthUserinfoFetchResponse>;
}
